import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../route/auth/auth.service';
import { AppUrls } from '../../route/app-urls';
import { AppConfig } from '../../appconfig';
import { SettingsService } from '../../shared/settings/settings.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lfw-auth-failed',
  templateUrl: './auth-failed.component.html',
  styleUrls: ['./auth-failed.component.css'],
  imports: [MatButton, MatTooltip, MatIcon, TranslatePipe]
})
export class AuthFailedComponent implements OnInit {
  private authService = inject(AuthService);
  private config = inject(AppConfig);
  private settingsService = inject(SettingsService);

  public longVersion = '';

  ngOnInit(): void {
    this.longVersion = 'Version ' + this.config.version();
  }

  login(e: any) {
    this.authService.login(AppUrls.baseUrlAngular);
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
